import type {
  CanvasSelectionSemanticItem,
  CanvasTemplateSemanticSpec,
} from '@streamlain/canvas-selection-contract';
import { normalizeCanvasSemanticText } from '@streamlain/canvas-selection-contract';

import FishboneTemplateSemanticSpec from './edgeless-semantics/Fishbone Diagram.json';
import SwotTemplateSemanticSpec from './edgeless-semantics/SWOT.json';

export const SWOT_TEMPLATE_SEMANTIC_SPEC =
  SwotTemplateSemanticSpec as CanvasTemplateSemanticSpec;

export const FISHBONE_TEMPLATE_SEMANTIC_SPEC =
  FishboneTemplateSemanticSpec as CanvasTemplateSemanticSpec;

export const builtInEdgelessTemplateSemanticSpecs = [
  SWOT_TEMPLATE_SEMANTIC_SPEC,
  FISHBONE_TEMPLATE_SEMANTIC_SPEC,
] as const satisfies readonly CanvasTemplateSemanticSpec[];

function itemTextMatchesTemplate(
  item: CanvasSelectionSemanticItem,
  spec: CanvasTemplateSemanticSpec
): boolean {
  const text = normalizeCanvasSemanticText(`${item.text ?? ''} ${item.label}`);
  return spec.labels.some(label =>
    text.includes(normalizeCanvasSemanticText(label))
  );
}

export function resolveBuiltInEdgelessTemplateSemanticSpec(input: {
  templateName?: string | null;
  items?: readonly CanvasSelectionSemanticItem[];
}): CanvasTemplateSemanticSpec | null {
  const templateName = input.templateName
    ? normalizeCanvasSemanticText(input.templateName)
    : '';
  if (templateName) {
    const byName = builtInEdgelessTemplateSemanticSpecs.find(spec =>
      spec.labels.some(label =>
        templateName.includes(normalizeCanvasSemanticText(label))
      )
    );
    if (byName) return byName;
  }

  const items = input.items ?? [];
  return (
    builtInEdgelessTemplateSemanticSpecs.find(spec =>
      items.some(item => itemTextMatchesTemplate(item, spec))
    ) ?? null
  );
}
